import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config';
import './NotificationBell.css';

const NotificationBell = () => {
    const [unreadCount, setUnreadCount] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (config.user) {
            fetchUnreadCount();
            // Poll for new notifications every 30 seconds
            const interval = setInterval(fetchUnreadCount, 30000);
            return () => clearInterval(interval);
        }
    }, []);

    const fetchUnreadCount = async () => {
        if (loading) return;

        setLoading(true);
        try {
            const response = await axios.get(`${config.apiUrl}/notification`, {
                headers: {
                    Authorization: config.token,
                },
            });

            if (response.data.success) {
                const unread = response.data.list.filter(n => n.is_read === 0).length;
                setUnreadCount(unread);
            }
        } catch (error) {
            console.error('Error fetching notification count:', error);
        } finally {
            setLoading(false);
        }
    };

    if (!config.user) {
        return null;
    }

    return (
        <div className="account notification-bell-container">
            <Link to="/notifications">
                <div className="header-link notification-bell">
                    <div className="bell-icon-wrapper">
                        <i className="bi bi-bell"></i>
                        {unreadCount > 0 && (
                            <span className="notification-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                        )}
                    </div>
                    {/* <p>Notifications</p> */}
                </div>
            </Link>
        </div>
    );
};

export default NotificationBell;
